import React from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch } from "react-redux";
import { setDrawerActiveMenu } from "../../store/features/webUtilitiesSlice";
import secureLocalStorage from "react-secure-storage";

// get base_url
const { protocol, hostname, port } = window.location;
const portPart = port ? `:${port}` : ""; // Include port if it exists
const fullURL = `${protocol}//${hostname}${portPart}`;

const menuOption = [
  {
    name: "Linked devices",
    key: 311,
    subtitle: "Add or remove devices",
    src: fullURL + "/images/deshboard/linker.png",
  },
  // {
  //   name: "Allergens",
  //   key: 312,
  //   subtitle: "Update allergy information",
  //   src: fullURL + "/images/deshboard/user.png",
  // },
  {
    name: "Meal preferences",
    key: 313,
    subtitle: "Update meal settings",
    src: fullURL + "/images/deshboard/fastingPreferences.png",
  },
  {
    name: "Workout preferences",
    key: 314,
    subtitle: "Update workout settings",
    src: fullURL + "/images/deshboard/workoutPreferences.png",
  },
  {
    name: "Fasting preferences",
    key: 315,
    subtitle: "Update fasting settings",
    src: fullURL + "/images/deshboard/fastingPreferences.png",
  },
  // {
  //   name: "Reset FastBetter",
  //   key: 316,
  //   subtitle: "Start all over again",
  //   src: fullURL + "/images/deshboard/reset.png",
  // },
];
export default function Menu() {
  const dispatch = useDispatch();
  const handleChangeSidebar = async (menu) => {
    secureLocalStorage.removeItem("backMenu");
    await dispatch(setDrawerActiveMenu(menu));
  };

  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(3));
    secureLocalStorage.removeItem("backMenu");
  };

  return (
    <div className="w-full h-full">
      <div className="w-full flex mb-2">
        <SideBarBack handleCloseDrawer={handleCloseDrawer} />
      </div>
      <div className="flex flex-col gap-2 mt-6 w-10/12 mx-auto pb-14">
        {menuOption.map((item, index) => (
          <div key={item.key} className={`fasweekdes sidemenubox`}>
            <div className="mode1">
              <div>
                <img loading="lazy" src={item.src} alt={item.name} />
              </div>
              <div className="tabroe">
                <div className="sidetest text-base leading-snug">
                  {item.name}
                </div>
                <div className="modesutittex text-gray-500 text-[11px]">
                  {item.subtitle}
                </div>
              </div>
            </div>
            <div
              className="cursor-pointer"
              onClick={() => handleChangeSidebar(item.key)}
            >
              <div className="sidearro">
                <img
                  loading="lazy"
                  src={fullURL + "/images/deshboard/chevron.webp"}
                  alt="chevron"
                />
              </div>
            </div>
          </div>
        ))}
        <div className={`fasweekdes sidemenubox cursor-pointer`}>
          <div className="mode1" onClick={() => handleChangeSidebar(317)}>
            <div>
              <img
                loading="lazy"
                src={fullURL + "/images/deshboard/logout.png"}
                alt={"logout"}
              />
            </div>
            <div className="tabroe">
              <div className="sidetest text-base leading-snug">{"Logout"}</div>
              <div className="modesutittex text-gray-500 text-[11px]">
                {"Come back soon !"}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
